"use strict";
/// <reference types="jquery"/>

var __importDefault = undefined && undefined.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_addon_1 = __importDefault(require("../Addons/moment-addon"));
//Ajout de règle de validation
$.validator.unobtrusive.adapters.add("datecompare", ["sup", "equal", "onlyequal", "otherpropertyname"], function (options) {
    options.rules["datecompare"] = options.params;
    options.messages["datecompare"] = options.message;
});
$.validator.addMethod("datecompare", function (value, element, params) {
    var sup = params.sup,
        equal = JSON.parse(params.equal),
        onlyEqual = JSON.parse(params.onlyequal),
        prop = params.otherpropertyname,
        valueDate = moment_addon_1.default(value, "DD/MM/YYYY"),
        compareDate = null;
    if (!prop) {
        compareDate = new Date();
    } else {
        var $prop = $("#" + prop);
        if (!$prop || !$prop.val()) {
            return true;
        }
        compareDate = moment_addon_1.default($prop.val(), "DD/MM/YYYY");
    }
    if (onlyEqual) {
        return equal ? valueDate === compareDate : valueDate !== compareDate;
    }
    if (JSON.parse(sup)) {
        return equal ? valueDate >= compareDate : valueDate > compareDate;
    }
    return equal ? valueDate <= compareDate : valueDate < compareDate;
});
$.validator.unobtrusive.adapters.add("frqRappelcompare", function (options) {
    options.rules["frqRappelcompare"] = options.params;
    options.messages["frqRappelcompare"] = options.message;
});
$.validator.addMethod("frqRappelcompare", function (value, element, params) {
    var $element = $(element),
        defVal = $element.parents(".parametrage").data("default-frequence-rappel");
    return defVal === 0 || !value || value <= defVal;
});


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Addons/jquery.validation.ts
// module id = 513
// module chunks = 0